import {propsReducer} from "utils/stateUtils";
import {SUBCONTRACTOR_SET_PROPS} from "actions";

const DEFAULT_STATE = {
  subContractors:[],
  subContractorDetails:null
};

export default propsReducer(SUBCONTRACTOR_SET_PROPS, DEFAULT_STATE);
